import styles from "./DashboardSkeleton.module.scss";

const DashboardSkeleton = () => {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.header} skeleton`} />
      <div className={styles.cards}>
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className={`${styles.card} skeleton`} />
        ))}
      </div>

      <div className={styles.contentRow}>
        <div className={styles.left}>
          <div className={`${styles.chart} skeleton`} />

          <div className={styles.doughnuts}>
            <div className={`${styles.doughnut} skeleton`} />
            <div className={`${styles.doughnut} skeleton`} />
          </div>
        </div>

        <div className={styles.right}>
          <div className={styles.infoWrap}>
            <div className={styles.stats}>
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className={`${styles.stat} skeleton`} />
              ))}
            </div>

            <div className={`${styles.users} skeleton`} />
          </div>

          <div className={styles.games}>
            <div className={`${styles.gamesBlock} skeleton`} />
            <div className={`${styles.gamesBlock} skeleton`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardSkeleton;
